// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"702":"story","715":"list","962":"home"}[chunkId] || chunkId) + "-" + {"137":"8f1952ff70d3f8ea3634","702":"c766bc1e59960c24767f","715":"644bd3781a7cdfdb9cdc","962":"5f5015b658d57833d496"}[chunkId] + ".css";
};